import { useMemo } from 'react';
import { detectInAppBrowser } from './inAppBrowser';
import type { InAppBrowserInfo } from './inAppBrowser.types';

/**
 * Reads the live User-Agent on the client. During SSR (no navigator) returns the
 * not-in-app default; the WebsiteBanner system mounts banners client-side via
 * useEffect anyway, so this is evaluated after hydration.
 */
export const useInAppBrowser = (): InAppBrowserInfo => useMemo(() => detectInAppBrowser(typeof navigator !== 'undefined' ? navigator.userAgent : null), []);
